import React, {
	ChangeEventHandler,
	Ref,
	useCallback,
	useImperativeHandle,
	useRef,
} from "react";

export interface InvisibleUploadInputRef {
	requestUpload: () => void;
}

export interface InvisibleUploadInputProps {
	accept?: string;
	onReceive?: (file: File) => void;
	ref?: Ref<InvisibleUploadInputRef>;
}

export default function InvisibleUploadInput(props: InvisibleUploadInputProps) {
	const inputRef = useRef<HTMLInputElement | null>(null);

	useImperativeHandle(
		props.ref,
		() => ({
			requestUpload: () => {
				inputRef.current!.click();
			},
		}),
		[],
	);

	const propsOnReceive = props.onReceive;
	const onFileSelect = useCallback(
		(event: React.FormEvent<HTMLInputElement>) => {
			propsOnReceive?.(event.currentTarget.files![0]);
			event.currentTarget.value = "";
		},
		[propsOnReceive],
	);

	return (
		<input
			ref={inputRef}
			style={{ display: "none" }}
			type="file"
			name="image"
			accept={props.accept}
			onChange={onFileSelect}
		/>
	);
}
